import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';

const Category = () => {
  const [industries, setIndustries] = useState([]);
  const navigate=useNavigate();
  useEffect(() => {
    const fetchindustries = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}industries/get-all-industries`);
        if (response.data && Array.isArray(response.data)) {
          setIndustries(response.data);
        } else {
          console.error('Unexpected API response format:', response.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchindustries();
  }, []);

  const extractClassName = (iconString) => {  
    if (iconString.includes('className=')) {
      const match = iconString.match(/className=["']([^"']+)["']/);
      return match ? match[1] : '';
    }
    return iconString.trim();
  };
    return (
        <>
            {/* <div className="site-breadcrumb">
            <div className="container">
            <h2 className="breadcrumb-title">Our Category</h2>
            <ul className="breadcrumb-menu">
                <li>
                <a href="index.html">Home</a>
                </li>
                <li className="active">Our Category</li>
            </ul>
            </div>
            <div className="hero-shape">
            <img 
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
            <img 
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
            <img 
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
            <img 
            loading="lazy"
            role="presentation"
            decoding="async"
            fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
            </div>
            </div> */}
            <Breadcrumb
        title="Our Category"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Our Category", active: true }
        ]}
      />
            <div className="category-area mt-50">
                <div className="container">
                    <div className="row">
                    <div
                        className="col-lg-6 mx-auto wow fadeInDown"
                        data-wow-duration="1s"
                        data-wow-delay=".25s"
                        style={{
                        visibility: "visible",
                        animationDuration: "1s",
                        animationDelay: "0.25s",
                        animationName: "fadeInDown",
                        }}
                    >
                        <div className="site-heading text-center">
                        <h2 className="site-title">Browse By Category</h2>
                        <p>Search Your Career Opportunity With Our Categories</p>
                        </div>
                    </div>
                    <div className="row">
                    {industries.length > 0 ? (
                        industries.map((industry) => {
                        const iconClass = extractClassName(industry.industry_icon);
                        return (
                            <div key={industry.id} className="col-md-6 col-lg-4 col-xl-3">
                            <Link className="category-item"
                            onClick={(e) => {
                                e.preventDefault(); 
                                navigate(
                                `/jobs?category=${encodeURIComponent(
                                  industry.name)}`);
                            }}
                            >
                              <div className=" category-icon" >
                                <span className='me-4 '><i className={iconClass} ></i></span>
                              </div>
                                <div className="category-content">
                                <h6>{industry.name}</h6>
                                <p>{industry.id} Jobs Available</p>
                                </div>
                            </Link>
                            </div>
                        );
                        })
                    ) : (
                        <div className="col-12 text-center">
                        <p>Loading categories...</p>
                        </div>
                    )}
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Category